import apiClient from "../apiClient";
import ENDPOINTS from "../endpoints";


export const addVehicleMake = async (data) => {
    const response = await apiClient.post(ENDPOINTS.VEHICLE_MAKERS, data);
    return response.data;
};

export const getVehicleMakes = async (data) => {
    const response = await apiClient.get(ENDPOINTS.VEHICLE_MAKERS,data);
    return response.data;
}


export const addVehicleModel = async (data) => {
    const response = await apiClient.post(ENDPOINTS.VEHICLE_MODELS, data);
    return response.data;
}

export const getVehicleModels = async (makerId) => {
    const response = await apiClient.get(`${ENDPOINTS.VEHICLE_MODELS}?maker_id=${makerId}`);
    return response.data;
}

export const getVehiclesList = async ({ page = 1, search = "", page_size = 5, filter = "ALL" }) => {
    const response = await apiClient.get(ENDPOINTS.VEHICLES, {
        params: {
        page,
        search,
        page_size,
        filter,
        },
    });
    return response.data;
};

export const getVehicleDetails = async (id) => {
    const response = await apiClient.get(ENDPOINTS.VEHICLES, {
        params: { vehicleId: id },
    });
  return response.data;
}

export const setVehicleStatus = async (id, isActive) => {
   const response = await apiClient.get(ENDPOINTS.VEHICLES, {
    params: { vehicleId: id, actionId: isActive },
  });
  return response.data;
}


export const addVehicle = async (data) => {
    const response = await apiClient.post(ENDPOINTS.VEHICLES, data);
    return response.data;
}


export const getFuelTypes = async () => {
    const response = await apiClient.get(ENDPOINTS.FUEL_TYPES);
    return response.data;
}
